// Shared avatar expression metadata (shape names and core types only).
export const EYE_SHAPE_NAMES = [
    'sunset',
    'bookmark',
    'bullet',
    'bandaid',
    'ghost',
    'boomerang',
    'bean',
    'fruitslice',
    'closed',
    'cross',
];
export const MOUTH_SHAPE_NAMES = [
    'watermelon',
    'peanut',
    'boat',
    'crescent',
    'bowl',
    'falcon',
    'muffin',
    'fannypack',
    'closed',
    'circle-small',
    'circle-large',
    'heart',
];
export function getAvailableShapeNames(facialFeature) {
    const shapeNames = facialFeature === 'eye' ? EYE_SHAPE_NAMES : MOUTH_SHAPE_NAMES;
    return shapeNames.filter((shapeName) => {
        if (shapeName === 'closed')
            return false;
        if (facialFeature === 'eye' && shapeName === 'cross')
            return false;
        if (facialFeature === 'mouth' &&
            (shapeName === 'circle-small' ||
                shapeName === 'circle-large' ||
                shapeName === 'heart')) {
            return false;
        }
        return true;
    });
}
export function getRandomShapeName(facialFeature) {
    const availableShapeNames = getAvailableShapeNames(facialFeature);
    return availableShapeNames[Math.floor(Math.random() * availableShapeNames.length)];
}
//# sourceMappingURL=expressions.js.map